var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"cashier-record-footer"},[_c('div',{staticClass:"cashier-record-footer__inner"},[_c('a',{staticClass:"cashier-record-footer__link",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer nofollow","aria-label":"工业和信息化部备案管理系统（新窗口打开）","title":"点击前往工信部备案管理系统查询备案信息"}},[_vm._v(" 鲁ICP备2024057224号 ")])])])
}]

export { render, staticRenderFns }